module.exports = __webpack_public_path__ + "assets/9e6362719e59d187895605833060d1f9.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/taylorice/Documents/Roc2/engine/public-src/spingames/panel/sounds/buttons/denoms/denom_01.mp3
 ** module id = 44
 ** module chunks = 0
 **/